import '../App.css';
import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Container, Grid2 as Grid, Typography } from '@mui/material';
import Activities from '../components/Activities';
import HomeRoom from '../components/HomeRoom';
import { useInView } from 'react-intersection-observer';

export default function Home() {
	const videoRef = useRef(null);

	const { ref: otaLogosRef, inView: otaLogosInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	const { ref: homeButtonsRef, inView: homeButtonsInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	function scrollToHash() {
		const hash = window.location.hash;
		if (!hash) return;

		const id = hash.substring(1); // remove '#'
		const el = document.getElementById(id);

		if (el) {
			el.scrollIntoView({ behavior: 'smooth' });
		} else {
			// Retry logic: keep checking for element up to 2s
			const interval = setInterval(() => {
				const elRetry = document.getElementById(id);
				if (elRetry) {
					elRetry.scrollIntoView({ behavior: 'smooth' });
					clearInterval(interval);
				}
			}, 100);

			setTimeout(() => clearInterval(interval), 2000);
		}
	}

	useEffect(() => {
		scrollToHash();
	}, []);

	useEffect(() => {
		const booking = document.querySelector('.booking');
		function handleScroll() {
			const scrollY = window.scrollY;
			// Clamp scrollY to a reasonable range, e.g., 0 to 500
			const maxScroll = 500;
			const ratio = Math.min(scrollY / maxScroll, 1);
			// Start at 241,241,241 and go up to 255,255,255
			const base = 241;
			const max = 255;
			const value = Math.round(base + (max - base) * ratio);
			if (booking) {
				booking.style.backgroundColor = `rgb(${value}, ${value}, ${value})`;
				booking.style.willChange = 'background-color';
			}
		}
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	return (
		<Container
			disableGutters
			maxWidth="false"
			sx={{
				width: '100%',
				maxWidth: '100vw',
				margin: '0',
				padding: '0',
				overflowX: 'hidden',
			}}
		>
			<section
				style={{
					position: 'relative',
					width: '100vw',
					height: '100vh',
					overflowY: 'scroll',
				}}
			>
				<img
					className="hero-logo"
					src="/logo_transparent.svg"
					alt="Logo"
				/>
				<p className="hero-text">YOUR ADVENTURE AWAITS</p>
				<video
					ref={videoRef}
					autoPlay
					loop
					muted
					playsInline
					className="hero-video"
				>
					<source
						src="https://thehighpoint.s3.ca-central-1.amazonaws.com/hero.mov"
						type="video/mp4"
					/>
				</video>
			</section>
			<section
				style={{
					position: 'relative',
					width: '100%',
					minHeight: '100vh',
					overflow: 'hidden',
				}}
			>
				<Container
					maxWidth="false"
					sx={{
						mx: 0,
						display: 'flex',
						justifyContent: 'center',
						flexDirection: 'column',
						'&.MuiContainer-root': {
							px: '0',
						},
					}}
				>
					<Grid className="booking">
						<Grid
							ref={otaLogosRef}
							className={`ota-logos ${otaLogosInView ? 'animate__animated animate__fadeInUp' : ''}`}
						>
							<a
								href="https://live.ipms247.com/booking/book-rooms-426634"
								className="book-now-in-home"
								target="_blank"
								rel="noopener noreferrer"
							>
								BOOK NOW
							</a>
						</Grid>
						<Grid
							ref={homeButtonsRef}
							className={`home-buttons ${homeButtonsInView ? 'animate__animated animate__fadeInUp' : ''}`}
						>
							<button
								className="button"
								onClick={() => {
									const el = document.getElementById('rooms');
									if (el) {
										el.scrollIntoView({
											behavior: 'smooth',
										});
									}
								}}
							>
								ROOMS
							</button>
							<button
								className="button"
								onClick={() => {
									const el =
										document.getElementById('activities');
									if (el) {
										el.scrollIntoView({
											behavior: 'smooth',
										});
									}
								}}
							>
								ACTIVITIES
							</button>
							<Link to="/contact" className="button">
								CONTACT
							</Link>
						</Grid>
					</Grid>
					<Grid>
						<HomeRoom />
					</Grid>
					<Grid>
						<Activities />
					</Grid>
				</Container>
			</section>
		</Container>
	);
}
